import { clsx } from 'clsx';

export type FilterStatus = 'all' | 'mine' | 'drafts' | 'review' | 'complete';

interface FilterTabsProps {
  activeFilter: FilterStatus;
  onFilterChange: (filter: FilterStatus) => void;
  counts: Record<FilterStatus, number>;
  availableFilters: FilterStatus[];
}

const filterLabels: Record<FilterStatus, string> = {
  all: 'All',
  mine: 'My Ideas',
  drafts: 'Drafts',
  review: 'In Review',
  complete: 'Complete',
};

export function FilterTabs({ activeFilter, onFilterChange, counts, availableFilters }: FilterTabsProps) {
  return (
    <div className="flex gap-1 border-b border-wolf-700/50">
      {availableFilters.map((filterKey) => (
        <button
          key={filterKey}
          onClick={() => onFilterChange(filterKey)}
          className={clsx(
            'px-4 py-3 text-sm font-medium transition-all duration-300 border-b-2 -mb-px',
            activeFilter === filterKey
              ? 'border-action text-wolf-100'
              : 'border-transparent text-wolf-500 hover:text-wolf-300'
          )}
        >
          {filterLabels[filterKey]}
          <span
            className={clsx(
              'ml-2 px-2 py-0.5 text-xs font-mono',
              activeFilter === filterKey
                ? 'bg-action/20 text-action'
                : 'bg-wolf-700/50 text-wolf-500'
            )}
          >
            {counts[filterKey]}
          </span>
        </button>
      ))}
    </div>
  );
}
